export default __webpack_public_path__ + "static/media/GoogleReview.69dc83f6.webp";